import React from 'react';
import { Spinner } from 'reactstrap';
import './loader.css';

const Loader = (props) => {
  return <Spinner className='mr-2 loader-style' />;
};

export default Loader;
